import {DefaultScreenDetector} from "./screen-detector/DefaultScreenDetector";

function prepareCartCount(element) {
    let input = element.querySelector('.cart-count-value');
    if (input) {
        if (DefaultScreenDetector.isMobileView()) {
            input.setAttribute('type', 'number');
        } else {
            input.setAttribute('type', 'text');
        }
    }
}

function initializeCartCount(element) {
    prepareCartCount(element);
    let input = element.querySelector('.cart-count-value');
    let incrementElement = element.querySelector('.cart-count-increment');
    let decrementElement = element.querySelector('.cart-count-decrement');

    if (input) {
        let min = parseInt(input.getAttribute('min'));
        let max = parseInt(input.getAttribute('max'));
        let valueControl = (value) => {
            let currentValue = parseInt(input.value) || 0;
            currentValue += value;
            if (currentValue > max) currentValue = max;
            if (currentValue < min) currentValue = min;
            input.value = currentValue;
        };
        input.addEventListener('change', () => {
            const value = parseInt(input.value);

            input.value = isNaN(value) ? min : value ;

            if (input.value > max) input.value = max;
            if (input.value < min) input.value = min;
        });

        if (incrementElement) {
            incrementElement.addEventListener('click', event => {
                event.preventDefault();
                valueControl(1);
            });
        }

        if (decrementElement) {
            decrementElement.addEventListener('click', event => {
                event.preventDefault();
                valueControl(-1);
            });
        }
    }
}


export class CartCountElement {
    constructor(element) {
        this.element = element;

        initializeCartCount(this.element);

        window.addEventListener("resize", () => {
            prepareCartCount(this.element);
        });
    }
}
